const Menus = [
  {
    title: 'Dashboard',
    route: '/dashboard',
    icon: 'dashboard',
    module: 'dashboard',
  },
  {
    title: 'Orders',
    icon: 'food',
    subMenuItems: {
      order: {
        title: 'F & B',
        route: '/orders',
        icon: 'food',
        module: 'orders',
      },
      express: {
        title: 'Express',
        route: '/express',
        icon: 'shipping fast',
        module: 'express',
      },
    },
  },
  {
    title: 'Marketing',
    icon: 'bullhorn',
    subMenuItems: {
      advertisement: {
        title: 'Advertisement',
        route: '/advertisement',
        icon: 'certificate',
        module: 'advertisement',
      },
      app_inbox: {
        title: 'In-App Inbox',
        route: '/app-inbox',
        icon: 'inbox',
        module: 'app_inbox',
      },
      promotions: {
        title: 'Promotions',
        route: '/promotions',
        icon: 'percent',
        module: 'promotions',
      },
      rewards: {
        title: 'Rewards',
        route: '/rewards',
        icon: 'gift',
        module: 'rewards',
      },
      lucky_draw_winners:{
        title: 'Lucky Draw Winners',
        route: '/lucky-draw-winners',
        icon: 'winner',
        module: 'lucky_draw_winners',
      }
    },
  },
  {
    title: 'Merchants',
    icon: 'home',
    subMenuItems: {
      merchant: {
        title: 'Restaurants',
        route: '/restaurants',
        icon: 'home',
        module: 'restaurants',
      },
      partners: {
        title: 'Partners',
        route: '/partners',
        icon: 'users',
        module: 'partners',
      },
      category: {
        title: 'Category',
        route: '/category',
        icon: 'list',
        module: 'category',
      },
      requests: {
        title: 'Close Requests',
        route: '/close-requests',
        icon: 'file alternate',
        module: 'merchant_close_requests',
      },
    },
  },
  {
    title: 'Drivers',
    icon: 'bicycle',
    subMenuItems: {
      drivers: {
        title: 'Drivers',
        icon: 'bicycle',
        route: '/drivers',
        module: 'drivers',
      },
      notification: {
        title: 'Notification',
        icon: 'envelope outline',
        route: '/notification',
        module: 'drivers',
      },
    },
  },
  {
    title: 'Customers',
    route: '/customers',
    icon: 'user',
    module: 'customers',
  },
  {
    title: 'Accounting',
    icon: 'money',
    subMenuItems: {
      cashout: {
        title: 'Cash-Outs',
        route: '/cashouts',
        icon: 'dollar',
        module: 'cashout',
      },
      cash_receivable: {
        title: 'Cash Receivable',
        route: '/cash-receivable',
        icon: 'money bill alternate outline',
        module: 'cash_receivable',
      },
      merchant_settlement: {
        title: 'Merchant Settlement',
        route: '/merchant-settlements',
        icon: 'chart bar outline',
        module: 'merchant_settlement',
      },
    },
  },
  {
    title: 'Reports',
    icon: 'pie graph',
    subMenuItems: {
      merchantReport: {
        title: 'Merchant',
        icon: 'home',
        route: '/reports/merchant',
        module: 'merchant_report',
      },
      operatorReport: {
        title: 'Operator',
        icon: 'computer',
        route: '/reports/operator',
        module: 'operator_report',
      },
      saleReport: {
        title: 'Sale',
        icon: 'money',
        route: '/reports/sale',
        module: 'sale_report',
      },
      promoCodeReport: {
        title: 'Discount',
        icon: 'percent',
        route: '/reports/discount',
        module: 'promocode_report',
      },
      refundReport: {
        title: 'Refund',
        icon: 'hdd',
        route: '/reports/refund',
        module: 'refund_report',
      },
      customerReport: {
        title: 'Customer',
        icon: 'user',
        route: '/reports/customer',
        module: 'customer_report',
      },
      promotionExpense: {
        title: 'Promotion Expense',
        icon: 'money',
        route: '/reports/promotion-expense',
        module: 'promotion_expense_report',
      },
      driverTransaction: {
        title: 'Driver Transaction',
        icon: 'bicycle',
        route: '/reports/driver-transactions',
        module: 'driver_transaction_report',
      },
      location: {
        title: 'Location',
        icon: 'map',
        route: '/reports/location',
        module: 'sale_report',
      },
      expressCod: {
        title: 'Express COD',
        icon: 'shipping fast',
        route: '/reports/express-cod',
        module: 'express_cod',
      },
    },
  },
  {
    title: 'App Customization',
    route: '/app-customization',
    icon: 'mobile alternate',
    module: 'app_customization',
  },
  {
    title: 'User & Permissions',
    icon: 'user doctor',
    subMenuItems: {
      users: {
        title: 'Users Management',
        route: '/users',
        icon: 'detective',
        module: 'users',
      },
      permissions: {
        title: 'Roles & Permissions',
        route: '/permissions',
        icon: 'shield',
        module: 'permissions',
      },
    },
  },
  {
    title: 'Configurations',
    route: '/configurations',
    icon: 'cogs',
    module: 'configurations',
  },
  {
    title: 'Service Availability',
    route: '/service-availability',
    icon: 'map marker alternate',
    module: 'service_availability',
  },
]

export default Menus



// WEBPACK FOOTER //
// ./src/layouts/Menus.js